// START GENAI@GHCOPILOT
// This function extracts the id from a url
// if url is https://sandbox.assets.vims.visa.com/vims/cardart/5af3734cca4e439e97f00e4474d82447_imageA@2x.png
// id is the string between last '/' and '.png' i.e 5af3734cca4e439e97f00e4474d82447_imageA@2x

const getIdFromUrl = (url: string): string => {
  return url.substring(url.lastIndexOf('/') + 1, url.length - 4);
};

export default getIdFromUrl;

// END GENAI@GHCOPILOT
